<template>
  <v-container fluid pa-0>
    <v-row justify="center" no-gutters>
      <v-col cols="auto">

        <!--        RESTART-->
        <v-btn @click="restart()"
               :disabled="disabled"
               color="white"
               icon
               class="mr-1"
        >
          <v-icon size="22">
            mdi-restore
          </v-icon>
        </v-btn>

        <!--        REWIND 5 SEC-->
        <v-btn @click="backward()"
               :disabled="disabled"
               color="white"
               icon
               class="mr-1"
        >
          <v-icon size="13" style="width:13px">
            mdi-minus
          </v-icon>
          <v-icon size="28" style="width:13px">
            mdi-numeric-5
          </v-icon>
        </v-btn>

        <!--        PLAY / PAUSE WITH PROGRESS AROUND-->
        <v-progress-circular :value="$store.state.media.currentProgress" size="50" rotate="270" class="mx-2"
                             :width="disabled ? 0 : 2 ">
          <v-btn @click="togglePlayPause()"
                 :disabled="disabled"
                 color="white"
                 icon
                 class="mx-2"

          >
            <v-icon size="35">
              {{ playPauseButton }}
            </v-icon>
          </v-btn>
        </v-progress-circular>

        <!--        FAST FORWARD 5 SEC-->
        <v-btn @click="forward()"
               :disabled="disabled"
               color="white"
               icon
        >
          <v-icon size="13" style="width:13px">
            mdi-plus
          </v-icon>
          <v-icon size="28" style="width:13px">
            mdi-numeric-5
          </v-icon>
        </v-btn>

        <!--        TRANSCRIPTION-->
        <v-btn color="white"
               icon
               v-if="hasAudioTranscript"
               @click="toggleTranscript()"
        >
          <v-icon>mdi-subtitles</v-icon>
        </v-btn>

        <!--        CAPTIONS-->
        <v-btn
            v-if="hasSubtitles"
            :color="showSubtitles ? 'white' : 'grey'"
               icon
               @click="toggleSubtitles()"
        >
          <v-icon>mdi-closed-caption</v-icon>
        </v-btn>

        <!--        VOLUME MENU-->
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn color="white"
                           icon
                           v-on="on"
                    >
                      <v-icon>{{volumeIcon}}</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-slider
                          color="accent"
                          :value="volume"
                          @change="setVolume($event)"
                          vertical
                      ></v-slider>
                    </v-card-text>
                  </v-card>
                </v-menu>
      </v-col>

<!--      <v-col cols="auto">-->
<!--        <v-slider-->
<!--            style="width: 150px;"-->
<!--            class="mt-2"-->
<!--            v-model="volume"-->
<!--            @change="setVolume(volume)"-->
<!--            append-icon="mdi-volume-high"-->
<!--            prepend-icon="mdi-volume-low"-->
<!--            color="accent"-->
<!--            @click:append="setVolume(volume+10)"-->
<!--            @click:prepend="setVolume(volume-10)"-->
<!--        ></v-slider>-->
<!--      </v-col>-->
    </v-row>
  </v-container>
</template>

<script>
  import ApplicationEventHub from "../../../events/applicationEventHub";

  export default {
    name: "MediaControls",
    components: {

    },
    data: () => ({

    }),
    computed: {
      playPauseButton() {
        return this.isPlaying ? 'mdi-pause' : 'mdi-play';
      },
      isPlaying() {
        return this.$store.state.media.isPlaying;
      },
      volume() {
        return this.$store.state.media.volume;
      },
      showSubtitles() {
        return this.$store.state.media.subtitlesActive;
      },
      hasSubtitles() {
        return this.$store.state.media.subtitlesAvailable;
      },
      hasAudioTranscript() {
        return !!this.$store.state.media.transcriptContent;
      },
      audioTranscriptActive() {
        return !!this.$store.state.media.transcriptActive;
      },
      volumeIcon() {
        return this.volume <= 0 ? 'mdi-volume-low' : this.volume <= 50 ? 'mdi-volume-medium' : 'mdi-volume-high'
      },
      disabled() {
        return !this.$store.state.media.ready;
      }
    },
    methods: {
      togglePlayPause() {
        if (this.$store.state.media.isPlaying) {
          ApplicationEventHub.pauseMedia();
        } else {
          ApplicationEventHub.playMedia();
        }
      },
      forward() {
        ApplicationEventHub.forwardMedia();
      },
      backward() {
        ApplicationEventHub.backwardMedia();
      },
      restart() {
        ApplicationEventHub.restartMedia();
      },
      setProgress(progress) {
        this.$set(this, 'progress', progress);
      },
      toggleSubtitles() {
        ApplicationEventHub.showMediaSubtitles(!this.$store.state.media.subtitlesActive);
      },
      setVolume(vol) {
        //NB do not use a watcher to update volume, it updates
        //to fast and lags the media. Only change the volume
        //once the user has finished dragging the volume slider
        this.$store.dispatch('media/setVolume', vol);
      },
      toggleTranscript(){
        this.$store.dispatch('media/toggleTranscript');
      }
    },
    beforeDestroy(){

    },
    mounted() {

    }
  }
</script>

<style scoped>

</style>
